module.exports = __webpack_public_path__ + "img/user.3d80db29.png";